import config from "../../config";
import $ from "jquery";
import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./style.css";
import addIcon from "../../images/icons/add.png";
import deleteIcon from "../../images/icons/delete.png";
import moment from "moment";
import Swal from "sweetalert2";
import {
  inputAlphanum,
  inputAlphanumeric,
  inputfourDigitDeciaml,
  inputOnlyNumber,
  millionComma,
  playBarcodeSound,
  removeMillionComma,
  userBackDate,
  getFilteredStockInTypes,
  isStockTransferOnly,
} from "../../utils";
import CommonAsyncSelect from "../../components/CommonAsyncSelect";
import stockAdjustmentSchema from "../../validations/stockAdjustmentSchema";
import axios from "axios";
import { uomConversion, uomConversionUnit } from "../Sale/util";
import TruncatedTextWithTooltip from "../../components/TruncatedTextWithTooltip";
import Tippy from "@tippyjs/react";
import { BiInfoCircle } from "react-icons/bi";
import { Modal } from "react-bootstrap";
import ItemViews from "../Master/Item/view";

function StockAdjustmentAdd(props) {
  const navigate = useNavigate();

  const [user, setUser] = useState("");
  const [userBranch, setUserBranch] = useState("");
  const [godown, setGodown] = useState([]);
  const [godownListAll, setGodownListAll] = useState([]);
  const [fGodown, setFGodown] = useState([]);

  const [defaultGodown, setDefaultGodown] = useState("");
  const [branchId, setBranchId] = useState(props?.userBrnch);
  const [stkAdjType, setStkAdjType] = useState("");

  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const handleItemView = (data) => {
    setSelectedItemId(data);
    setShowItemModal(true);
  };
  const handleItemModalClose = () => {
    setShowItemModal(false);
    setSelectedItemId(null);
  };

  console.log("branchId", user);

  const [itemList, setItemList] = useState([]);
  const [itemLoading, setItemLoading] = useState(false);

  async function getItem() {
    setItemLoading(true);
    let branch_id = userBranch;
    if (!branch_id && localStorage.getItem("inventory")) {
      branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data?.[0]?.branch_id;
    }

    try {
      await $.post(
        `${config.apiUrl}/item/listItem`,
        JSON.stringify({
          paginate: 0,
          is_active: 1,
          branch_id: branch_id || "",
          is_preload: 1,
        }),
        function (res) {
          setItemList(res?.data?.list || []);
        }
      );
    } catch (err) {
      console.error("Item API Error", err);
      setItemList([]);
    } finally {
      setItemLoading(false);
    }
  }

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
      setUserBranch(
        JSON.parse(localStorage.getItem("inventory")).userData?.branch_data[0]
          ?.branch_id,
      );
    }
  }, []);

  useEffect(() => {
    getItem();
  }, []);

  useEffect(
    function () {
      setGodown(() => props?.godown);
      setGodownListAll(() => props?.godownListAll);
      setFGodown(() => props?.godown);
    },
    [props?.godown, props?.godownListAll],
  );

  useEffect(() => {
    if (props?.userBrnch) {
      setBranchId(props.userBrnch);
    }
  }, [props?.userBrnch]);

  const itemDtl = {
    item_id: "",
    item_name: "",
    qty: "",
    rate: "",
    amount: "",
    godown_id: defaultGodown,
    alt_conv: "",
    base_uom: "",
    alt_uom: "",
    uom: "",
    alt_qty: "",
    alt_price: "",
    alt_rate: "",
    base_rate: "",
  };

  const initialState = {
    stk_adj_type: "",
    branch_id: "",
    narration: "",
    stk_adj_date: moment().format("YYYY-MM-DD"),
    item_dtl: [itemDtl],
    from_branch: "",
    to_branch: "",
    from_godown: "",
    to_godown: "",
    vehicle_no: "",
  };

  const [formInputs, setFormInputs] = useState(initialState);
  const [selectedBuyer, setSelectedBuyer] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedProduct, setSelectedProduct] = useState([]);


  useEffect(() => {
    if (user && isStockTransferOnly(user)) {
      setStkAdjType("1");
      setFormInputs((prevState) => ({
        ...prevState,
        from_branch: user?.branch_data?.[0]?.branch_id || props?.userBrnch,
      }));
    }
  }, [user, props?.userBrnch]);

  // console.log("selectedBranchselectedBranchsel",selectedBranch)

  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const [barcode, setBarcode] = useState("");
  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const [highlightedRow, setHighlightedRow] = useState(null);
  const barcodeRef = useRef();

  const defaultGodownRef = useRef("");
  const godownRef = useRef([]);

  useEffect(() => {
    defaultGodownRef.current = defaultGodown;
    godownRef.current = godownListAll;
  }, [defaultGodown, godownListAll]);


  const totalRef = useRef(0);
  const focus = useRef([{}]);

  // function calculateTotal() {
  //   totalRef.current.value = 0;
  //   formInputs.item_dtl.forEach((item) => {
  //     let total = isNaN(parseFloat(totalRef.current.value))
  //       ? 0
  //       : parseFloat(totalRef.current.value);
  //     let total_amt = isNaN(parseFloat(item.amount))
  //       ? 0
  //       : parseFloat(item.amount);
  //     totalRef.current.value = parseFloat(total + total_amt).toFixed(4);
  //   });

  //   setSelectedProduct((prevState) => {
  //     return formInputs.item_dtl;
  //   });
  // }

  function calculateTotal() {
    totalRef.current.value = 0;
    formInputs.item_dtl.forEach((item) => {
      totalRef.current.value = removeMillionComma(totalRef.current.value);
      let total = isNaN(parseFloat(totalRef.current.value))
        ? 0
        : parseFloat(totalRef.current.value);
      let total_amt = isNaN(parseFloat(item.amount))
        ? 0
        : parseFloat(item.amount);
      let amt = parseFloat(total + total_amt).toFixed(2);
      totalRef.current.value = millionComma(amt);
    });

    setSelectedProduct((prevState) => {
      return formInputs.item_dtl;
    });
  }

  function handleInputs(e) {
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        [e.target.name]: e.target.value,
      };
      // if (
      //   stkAdjType == "1" &&
      //   newState.from_godown != null &&
      //   newState.from_godown != ""
      // ) {
      //   newState.item_dtl = newState.item_dtl.map((item) => ({
      //     ...item,
      //     godown_id: newState.from_godown,
      //   }));
      // }

      return newState;
    });
  }

  const [frombranch, setFrombranch] = useState();
  const [tobranch, setTobranch] = useState(true);
  const [togd, setTogd] = useState();
  const [allbranch, setAllbranch] = useState();
  const [filterfromgd, setFilterfromgd] = useState();
  const [godownList, setGodownList] = useState();
  const [fgodownList, setFGodownList] = useState();

  useEffect(() => {
    $.post(
      `${config.apiUrl}/godown/listGodown`,
      JSON.stringify({
        paginate: 0,
        is_active: 1,
      }),
      function (res) {
        setFGodownList(res?.data?.list || []);
      },
    );
  }, []);

  useEffect(() => {
    if (fgodownList && branchId) {
      const filtered = fgodownList
        .filter((el) =>
          Array.isArray(el?.branch_id)
            ? el.branch_id.some((b) => Number(b) === Number(branchId))
            : Number(el?.branch_id) === Number(branchId)
        )
        .map((el) => ({
          label: el?.godown_name,
          value: el?.godown_id,
          branch_id: el?.branch_id,
        }));
      setGodown(filtered);
    }
  }, [fgodownList, branchId]);

  const [tobranchid, setTobranchid] = useState();
  // console.log("tobranchid", tobranchid)
  useEffect(() => {
    $.post(
      `${config.apiUrl}/godown/listGodown`,
      JSON.stringify({
        paginate: 0,
        is_active: 1,
        branch_id: tobranchid,
      }),
      function (res) {
        setGodownList(res?.data?.list || []);
      },
    );
  }, [tobranchid]);
  const token = JSON.parse(localStorage.getItem("inventory")).token;
  useEffect(() => {
    const axiosConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const fetchData = async () => {
      if (localStorage.getItem("inventory")) {
        try {
          const response = await axios.post(
            `${config.apiUrl}/branch/listBranch`,
            JSON.stringify({
              paginate: 0,
              is_active: 1,
            }),
            axiosConfig,
          );
          setAllbranch(response?.data?.data.list);
        } catch (error) { }
      }
    };

    fetchData();
  }, []);

  const [filbranch, setFilbranch] = useState([]);
  const [togdlistdes, setTogdlistdes] = useState(true);
  const filterbranch = allbranch?.filter((ele) => {
    return ele.branch_id == props.userBrnch;
  });

  function handleTableInputs(e, rowIndex) {
    let idx =
      rowIndex !== undefined
        ? rowIndex
        : window.event?.target?.closest("tr")?.getAttribute("data-id") ||
        window.event?.srcElement?.closest("tr")?.getAttribute("data-id");

    setHighlightedRow(Number(idx));

    let product = formInputs.item_dtl[idx];
    if (e.target.name == "item_id") {
      product = e.target.value;
    }

    let rate =
      e.target.name == "rate"
        ? e.target.value
        : product?.rate || product?.item_price || 0;
    let base_rate = product?.base_rate || rate;
    let alt_rate = product?.alt_rate || product?.alt_price || 0;

    let alt_price =
      e.target.name == "alt_price"
        ? e.target.value
        : product?.alt_price || product?.alt_price || 0;
    let qty = e.target.name == "qty" ? e.target.value : product.qty || 1;
    // let grossAmt = parseFloat(parseFloat(rate) * parseFloat(qty)).toFixed(4);
    // let godown_id =
    //   e.target.name == "godown_id" ? e.target.value : product.godown_id;
    let currentGodownList = godownRef.current.map((x) => Number(x.godown_id));

    let preferredId = Number(
      product?.godown_id ||
      product?.item_godown ||
      (product?.item_godown_data?.length > 0
        ? product.item_godown_data[0].godown_id
        : 0),
    );

    let godown_id = defaultGodownRef.current;
    if (e.target.name === "godown_id") {
      godown_id = e.target.value;
    } else if (
      preferredId &&
      preferredId !== 0 &&
      currentGodownList.includes(preferredId)
    ) {
      godown_id = String(preferredId);
    }

    let alt_conv = product?.alt_conv;
    let base_uom = product?.base_uom || product?.item_unit;
    let alt_uom = product?.alt_uom || product?.alt_unit;
    let base_conv = parseFloat(product?.base_conv || 1);
    let uom =
      e.target.name == "uom"
        ? e.target.value
        : product.uom || product.base_uom || product?.item_unit;

    let alt_qty = product?.alt_conv || 1;

    alt_qty = parseFloat(alt_conv) / parseFloat(base_conv);

    if (e.target.name == "uom") {
      // qty = product.alt_qty;
      alt_price = alt_rate;
      rate = base_rate;
    }

    if (uom == alt_uom) {
      alt_qty =
        product.alt_conv == 1 ? parseFloat(base_conv) : base_conv / alt_conv;
      // rate = alt_price * alt_conv;
      rate = (alt_price * alt_conv).toFixed(4);
    } else if (uom === base_uom) {
      // alt_price = rate / alt_conv;
      alt_price = (rate / alt_conv).toFixed(4);
    }

    const grossAmt =
      uom === base_uom
        ? parseFloat(rate * qty).toFixed(4)
        : parseFloat(
          rate * (parseFloat(alt_qty) * parseFloat(qty)).toFixed(2),
        ).toFixed(4);

    const gAmt = Number(grossAmt);
    let prodDtl = {
      item_id: product.item_id,
      item_name: product.item_name,
      qty: qty,
      rate: rate,
      godown_id: godown_id,
      amount: isNaN(grossAmt) ? 0 : grossAmt,
      alt_conv: alt_conv,
      base_uom: base_uom,
      alt_uom: alt_uom,
      uom: uom,
      alt_price: alt_price,
      alt_rate: alt_rate,
      base_rate: base_rate,
      alt_qty: (parseFloat(alt_qty) * parseFloat(qty)).toFixed(4),
    };
    let existProdDtl = formInputs.item_dtl;
    existProdDtl[idx] = prodDtl;
    setFormInputs((prevState) => {
      let newState = {
        ...prevState,
        item_dtl: existProdDtl,
      };
      return newState;
    });
  }

  const handleBarcodeInput = (item) => {
    setFormInputs((prev) => {
      let existItemIndex = prev.item_dtl.findIndex(
        (row) => row.item_id == item.item_id,
      );

      if (existItemIndex !== -1) {
        // Increment quantity in existing row
        setHighlightedRow(existItemIndex);
        setTimeout(() => {
          let currentQty = parseFloat(prev.item_dtl[existItemIndex].qty || 0);
          handleTableInputs(
            {
              target: { name: "qty", value: currentQty + 1 },
            },
            existItemIndex,
          );
        }, 1);
        return prev;
      } else {
        // Add new item
        let emptyRowIndex = prev.item_dtl.findIndex((row) => !row.item_id);
        let newIdx =
          emptyRowIndex !== -1 ? emptyRowIndex : prev.item_dtl.length;

        setHighlightedRow(newIdx);

        setSelectedProduct((prevState) => {
          let newState = [...prevState];
          newState[newIdx] = item;
          return newState;
        });

        if (emptyRowIndex !== -1) {
          setTimeout(() => {
            handleTableInputs(
              {
                target: { name: "item_id", value: item },
              },
              emptyRowIndex,
            );
          }, 1);
          return prev;
        } else {
          let updatedItemDtl = [...prev.item_dtl, itemDtl];
          setTimeout(() => {
            handleTableInputs(
              {
                target: { name: "item_id", value: item },
              },
              newIdx,
            );
          }, 1);
          return { ...prev, item_dtl: updatedItemDtl };
        }
      }
    });
  };

  const scanBarcode = (e) => {
    if (e) e.preventDefault();
    if (isSubmit) return;
    if (!barcode || barcode.trim().length < 2) return;

    setBarcodeLoading(true);
    $.post(
      `${config.apiUrl}/item/listItem`,
      JSON.stringify({
        paginate: 0,
        is_active: 1,
        barcode: barcode.trim(),
      }),
      (res) => {
        setBarcodeLoading(false);
        let list = res?.data?.list || [];
        if (list.length > 0) {
          playBarcodeSound(true);
          handleBarcodeInput(list[0]);
          setBarcode("");
          setTimeout(() => {
            if (barcodeRef.current) barcodeRef.current.focus();
          }, 200);
        } else {
          playBarcodeSound(false);
          Swal.fire({
            html: "Product not available of this barcode",
            icon: "error",
            confirmButtonText: "Close",
            allowEnterKey: true,
            allowEscapeKey: true,
            didOpen: () => {
              Swal.getConfirmButton().focus();
            },
          }).then(() => {
            setBarcode("");
            setTimeout(() => {
              if (barcodeRef.current) barcodeRef.current.focus();
            }, 200);
          });
        }
      },
    );
  };

  function handleItemCount(v, i) {
    if (v == "+") {
      if (formInputs.item_dtl[formInputs.item_dtl.length - 1].item_id == "") {
        Swal.fire({ html: "Please fill proper data." });
      } else {
        let existProdDtl = formInputs.item_dtl;
        existProdDtl[formInputs.item_dtl.length] = itemDtl;
        setFormInputs({ ...formInputs, item_dtl: existProdDtl });
      }
    } else if (v == "-") {
      if (formInputs.item_dtl.length == 1) {
        Swal.fire({ html: "Can't delete last row." });
      } else {
        let existProdDtl = formInputs.item_dtl.filter((v, idx) => {
          return idx != i;
        });
        setFormInputs({ ...formInputs, item_dtl: existProdDtl });
      }
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (formInputs.item_dtl.length > 1) {
      formInputs.item_dtl = formInputs.item_dtl.filter((p) => p.item_id != "");
    }
    if (stkAdjType == "") {
      Swal.fire({ html: "Stock Adjustment Type is required." });
      return;
    }
    if (formInputs.date == "") {
      Swal.fire({ html: "Date is required." });
      return;
    }
    if (formInputs.narration == "") {
      Swal.fire({ html: "Narration is required." });
      return;
    }
    if (stkAdjType == 1) {
      if (formInputs.from_godown == "") {
        Swal.fire({ html: "From Godown is required." });
        return;
      }
      if (formInputs.to_branch == "") {
        Swal.fire({ html: "To Branch is required." });
        return;
      }
      if (formInputs.to_godown == "") {
        Swal.fire({ html: "To Godown is required." });
        return;
      }
      formInputs.item_dtl = formInputs.item_dtl.map((ele, ind) => {
        ele.godown_id = formInputs.from_godown;
        return ele;
      });
    }

    if (formInputs.item_dtl) {
      formInputs.item_dtl.map((ele, ind) => {
        if (ele.qty == "0") {
          Swal.fire({ html: "Qty is Required" });
          return;
        }
      });
    }
    let prod = [...formInputs.item_dtl];
    for (let i = 0; i < prod.length; i++) {
      let element = {};
      element = prod[i];
      if (element.qty == "0") {
        Swal.fire({ html: "Qty  should be greater than 0" });
        return;
        // prod[i] = newProdDtl;
      }
    }
    if (formInputs.narration.length > 100) {
      Swal.fire({ html: "Narration max length is 100 characters" });
      return;
    }
    // if (!/^[a-zA-Z0-9]+$/.test(formInputs.narration)) {
    //   Swal.fire({
    //     html: "Narration must contain only alphanumeric characters",
    //   });
    //   return;
    // }

    const fromDataMap = {
      branch_id: formInputs.branch_id || branchId || user?.branch_data?.[0]?.branch_id || props.userBrnch,
      item_dtl: formInputs.item_dtl,
      stk_adj_date: formInputs.stk_adj_date,
      narration: formInputs.narration,
      stk_adj_type: Number(stkAdjType),
      from_branch: formInputs.from_branch || props.userBrnch,
      to_branch: formInputs.to_branch,
      from_godown: formInputs.from_godown,
      to_godown: formInputs.to_godown,
      vehicle_no: formInputs?.vehicle_no,
    };

    let isInvalid = await stockAdjustmentSchema.validateAdd(fromDataMap);
    if (isInvalid?.errors) {
      Swal.fire("", isInvalid.errors[0]);
      return;
    }

    formInputs.branch_id = JSON.parse(
      localStorage.getItem("inventory"),
    )?.userData?.branch_data?.[0]?.branch_id;
    formInputs.amount = totalRef.current.value;

    let prod1 = [...fromDataMap.item_dtl];

    for (let i = 0; i < prod1.length; i++) {
      let element = {};
      element = prod1[i];
      if (element.uom == element.alt_uom) {
        let newProdDtl = {
          ...element,
          qty: element.alt_qty,
          alt_qty: element.qty,
        };
        prod1[i] = newProdDtl;
      }
    }

    let newFormData = {
      ...fromDataMap,
      item_dtl: prod1,
    };

    setIsSubmit(true);
    await $.post(
      `${config.apiUrl}/StockAdjustment/createStockAdjustment`,
      JSON.stringify(newFormData),
    )
      .done(function (res) {
        let title = res.status == 200 ? "Success" : "Error";
        Swal.fire({
          title: title,
          html: `
          Voucher No: <b>${res?.data?.stk_adj_no || "N/A"}
              `,
          showConfirmButton: true,
          confirmButtonText: isStockTransferOnly(user) ? "Create New Stock Transfer" : "Create New Stock Adjustment",
          showCancelButton: true,
          cancelButtonText: "Back to List",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        }).then((event) => {
          if (event.isConfirmed) {
            navigate("/stock-adjustment/add");
          } else if (event.isDismissed) {
            navigate("/stock-adjustment");
          }
        });
        totalRef.current.value = 0;
        setFormInputs(initialState);
        setStkAdjType("");
        setSelectedBuyer("");
        setSelectedBranch("");
        setTobranchid("");
        setSelectedProduct([]);
      })
      .catch(function (err) {
        Swal.fire({
          title: "Error",
          text: err?.responseJSON?.data?.message || err?.responseJSON?.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
      })
      .always(function () {
        setIsSubmit(false);
      });
  }

  useEffect(function () {
    focus?.current[0]?.branch_id?.focus();
  }, []);

  useEffect(
    function () {
      calculateTotal();
    },
    [formInputs],
  );

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2 position-relative pb-8">
          <Header />
          <Breadcrumb
            path={
              isStockTransferOnly(user)
                ? ["Stock Transfer", "Add Stock Transfer"]
                : ["Stock Adjustment", "Add Stock Adjustment"]
            }
          />

          <main className="bg-white rounded-2" id="purchaseAdd">
            <div className="container-fluid p-2 position-relative">
              <Link
                to="/stock-adjustment"
                className="position-absolute text-decoration-none small"
                style={{ top: "-1.5rem", right: "0" }}
              >
                Go Back to List
              </Link>
              <form autoComplete="off">
                <div className="row gx-3 mb-2">
                  {user.role_id !== 3 && user.role_id !== 8 ? (
                    <div className="col-md-3">
                      <label htmlFor="branch_id">
                        Branch Name
                        <span className="text-danger">*</span>
                      </label>
                      <CommonAsyncSelect
                        ref={(el) => (focus.current[0].branch_id = el)}
                        noOptionsMessage={() => null}
                        placeholder="Enter atleast 3 character"
                        getOptionLabel={(o) => o.branch_name}
                        getOptionValue={(o) => o.branch_id}
                        loadOptions={async (inputValue, callback) => {
                          if (inputValue.toString().length > 2) {
                            await $.post(
                              `${config.apiUrl}/branch/listBranch`,
                              JSON.stringify({
                                paginate: 0,
                                is_active: 1,
                                branch_name: inputValue,
                              }),
                              function (res) {
                                callback(res?.data?.list || []);
                              },
                            );
                          } else {
                            callback([]);
                          }
                        }}
                        value={selectedBuyer}
                        onChange={(e) => {
                          setSelectedBuyer(e);
                          setFormInputs((prevState) => {
                            setBranchId(e.branch_id);
                            let newState = {
                              ...prevState,
                              branch_id: e.branch_id,
                            };
                            return newState;
                          });
                          focus.current[0].inv_no.focus();
                        }}
                        components={{
                          IndicatorsContainer: () => null,
                        }}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            minHeight: "0px",
                            height: "29px",
                          }),
                          valueContainer: (baseStyles, state) => ({
                            ...baseStyles,
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            minHeight: "0px",
                            height: "29px",
                          }),
                          input: (baseStyles, state) => ({
                            ...baseStyles,
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            marginTop: "0px",
                            marginBottom: "0px",
                            minHeight: "0px",
                            height: "29px",
                          }),
                          dropdownIndicator: (baseStyles, state) => ({
                            ...baseStyles,
                            paddingTop: "0px",
                            paddingBottom: "0px",
                          }),
                          option: (baseStyles, state) => ({
                            ...baseStyles,
                            paddingTop: "0px",
                            paddingBottom: "0px",
                          }),
                        }}
                        classNamePrefix="react-select"
                        tabSelectsValue
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-md-3">
                    <label htmlFor="default_godown">
                      Stock Adjustment Type{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <select
                      ref={(el) => (focus.current.stk_adj_type = el)}
                      className="form-select"
                      value={stkAdjType}
                      onChange={(e) => {
                        setStkAdjType(e.target.value);

                        if (e.target.value == 1) {
                          setFormInputs((prevState) => {
                            let newState = {
                              ...prevState,
                              from_branch: filterbranch
                                ? filterbranch[0]?.branch_id
                                : props.userBrnch,
                            };
                            return newState;
                          });
                        } else {
                          setFormInputs((prevState) => {
                            let newState = {
                              ...prevState,
                              from_branch: "",
                              to_branch: "",
                              from_godown: "",
                              to_godown: "",
                            };
                            return newState;
                          });
                        }
                      }}
                    >
                      <option value="" hidden>
                        Select...
                      </option>
                      {props?.stockInType &&
                        getFilteredStockInTypes(props?.stockInType, user).map((list) => (
                          <option value={list.value}>{list.label}</option>
                        ))}
                    </select>
                    {/* {formErrors.stk_adj_type && (
                      <p className="text-danger">{formErrors.stk_adj_type}</p>
                    )} */}
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="stk_adj_date">
                      Date <span className="text-danger">*</span>
                    </label>
                    <input
                      // min={moment().subtract(30, "days").format("YYYY-MM-DD")}
                      min={userBackDate()}
                      max={moment().format("YYYY-MM-DD")}
                      ref={(el) => (focus.current[0].stk_adj_date = el)}
                      type="date"
                      className="form-control"
                      name="stk_adj_date"
                      value={formInputs.stk_adj_date}
                      onChange={(e) => {
                        handleInputs(e);
                      }}
                      onKeyDown={(e) => {
                        if (e.key == "Tab") {
                          return;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="narration">
                      Narration <span className="text-danger">*</span>
                    </label>
                    <input
                      ref={(el) => (focus.current[0].narration = el)}
                      type="text"
                      className="form-control"
                      name="narration"
                      value={formInputs.narration}
                      onChange={handleInputs}
                      onKeyDown={inputAlphanum}
                    />
                    {/* {formErrors.narration && (
                      <p className="text-danger">{formErrors.narration}</p>
                    )} */}
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="vehicle_no">Vehicle No</label>
                    <input
                      ref={(el) => (focus.current[0].vehicle_no = el)}
                      type="text"
                      className="form-control"
                      name="vehicle_no"
                      value={formInputs.vehicle_no}
                      maxLength={20}
                      onChange={handleInputs}
                      onKeyDown={inputAlphanum}
                    />
                    {/* {formErrors.narration && (
                      <p className="text-danger">{formErrors.narration}</p>
                    )} */}
                  </div>
                  {stkAdjType == 1 && (
                    <>
                      <div className="col-md-3">
                        <label htmlFor="narration">
                          From Branch <span className="text-danger">*</span>
                        </label>
                        <input
                          ref={(el) => (focus.current[0].narration = el)}
                          type="text"
                          className="form-control"
                          name="narration"
                          value={filterbranch && filterbranch[0].branch_name}
                          disabled
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="narration">
                          From Godown <span className="text-danger">*</span>
                        </label>
                        <select
                          // disabled={godown.length === 0 ? true : false}
                          className="form-select"
                          name="from_godown"
                          value={formInputs.from_godown}
                          onChange={(e) => {
                            handleInputs(e);
                            // if (selectedBranch) {
                            //   if (
                            //     filterbranch &&
                            //     filterbranch[0].branch_id ==
                            //       selectedBranch.branch_id
                            //   ) {
                            //     // let branchVise = togd.filter(
                            //     //   (f) => selectedBranch.branch_id == f.branch_id
                            //     // );
                            //     // let final = branchVise.filter(
                            //     //   (f) => formInputs.from_godown != f.godown_id
                            //     // );
                            //     // setFilterfromgd(final);
                            //     setFilterfromgd(() =>
                            //     togd.filter(
                            //         (f) => f.godown_id != e.target.value
                            //       )
                            //     );
                            //   } else {
                            //     setFilterfromgd(
                            //       togd.filter(
                            //         (f) =>
                            //           selectedBranch.branch_id == f.branch_id
                            //       )
                            //     );
                            //   }
                            // }
                          }}
                        >
                          <option value="" hidden>
                            Select...
                          </option>
                          {fGodown &&
                            fGodown.map((list) => {
                              // if (list.branch_id === branchId) {
                              return (
                                <option value={list.value}>{list.label}</option>
                              );
                              // }
                            })}
                        </select>
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="narration">
                          To Branch <span className="text-danger">*</span>
                        </label>
                        <CommonAsyncSelect
                          ref={(el) => (focus.current[0].to_branch = el)}
                          noOptionsMessage={() => null}
                          placeholder="Enter atleast 3 character"
                          getOptionLabel={(o) => o.branch_name}
                          getOptionValue={(o) => o.branch_id}
                          loadOptions={async (inputValue, callback) => {
                            if (inputValue.toString().length > 2) {
                              await $.post(
                                `${config.apiUrl}/branch/listBranch`,
                                JSON.stringify({
                                  paginate: 0,
                                  is_active: 1,
                                  branch_name: inputValue,
                                }),
                                function (res) {
                                  callback(res?.data?.list || []);
                                },
                              );
                            } else {
                              callback([]);
                            }
                          }}
                          value={selectedBranch}
                          onChange={(e) => {
                            setSelectedBranch(e);
                            // let branchVise = fgodownList.filter(
                            //   (f) => e.branch_id == f.branch_id
                            // );
                            setTobranchid(e.branch_id);
                            let branchVise = fgodownList.filter((f) =>
                              f.branch_id?.includes(e.branch_id),
                            );
                            setGodownList(branchVise);
                            if (
                              filterbranch &&
                              filterbranch[0].branch_id == e.branch_id
                            ) {
                              let final = branchVise.filter(
                                (f) => formInputs.from_godown != f.godown_id,
                              );

                              setGodownList(final);
                            } else {
                              setGodownList(branchVise);
                            }

                            setFormInputs((prevState) => {
                              // setBranchId(e.branch_id);
                              setTogdlistdes(false);
                              let newState = {
                                ...prevState,
                                to_branch: e.branch_id,
                              };

                              return newState;
                            });
                            // focus.current[0].inv_no?.focus();
                          }}
                          components={{
                            IndicatorsContainer: () => null,
                          }}
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: "0px",
                            }),
                            valueContainer: (baseStyles, state) => ({
                              ...baseStyles,
                              paddingTop: "0px",
                              paddingBottom: "0px",
                            }),
                            input: (baseStyles, state) => ({
                              ...baseStyles,
                              paddingTop: "0px",
                              paddingBottom: "0px",
                              marginTop: "0px",
                              marginBottom: "0px",
                            }),
                            dropdownIndicator: (baseStyles, state) => ({
                              ...baseStyles,
                              paddingTop: "0px",
                              paddingBottom: "0px",
                            }),
                            option: (baseStyles, state) => ({
                              ...baseStyles,
                              paddingTop: "0px",
                              paddingBottom: "0px",
                            }),
                          }}
                          classNamePrefix="react-select"
                          tabSelectsValue
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="narration">
                          To Godown <span className="text-danger">*</span>
                        </label>
                        <select
                          disabled={togdlistdes}
                          className="form-select"
                          name="to_godown"
                          value={formInputs.to_godown}
                          onChange={(e) => {
                            handleInputs(e);
                            setFGodown(() =>
                              godown.filter((f) => f.value != e.target.value),
                            );
                            if (formInputs.from_godown == e.target.value) {
                              setFormInputs((prevState) => {
                                let newState = {
                                  ...prevState,
                                  from_godown: "",
                                };

                                return newState;
                              });
                            }
                          }}
                        >
                          <option value="" hidden>
                            Select...
                          </option>
                          {godownList &&
                            godownList.map((list) => {
                              // if (list.branch_id === branchId) {
                              return (
                                <option value={list.godown_id}>
                                  {list.godown_name}
                                </option>
                              );
                              // }
                            })}
                        </select>
                      </div>
                    </>
                  )}
                </div>
                <div className="row gx-3 gy-2">
                  <div className="col-12">
                    <table
                      className="table mt-3 rounded"
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>
                            <div className="d-flex align-items-center gap-2">
                              Item Name <span className="text-danger">*</span>
                              <div className="position-relative d-flex align-items-center">
                                <input
                                  ref={barcodeRef}
                                  type="text"
                                  className="form-control form-control-sm"
                                  style={{ width: "120px" }}
                                  placeholder="Scan Barcode"
                                  value={barcode}
                                  onChange={(e) => setBarcode(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      scanBarcode(e);
                                    }
                                  }}
                                />
                                {barcodeLoading && (
                                  <div
                                    className="position-absolute end-0 me-2"
                                    style={{ zIndex: 10 }}
                                  >
                                    <span
                                      className="spinner-border spinner-border-sm text-primary"
                                      role="status"
                                      aria-hidden="true"
                                      style={{
                                        width: "0.8rem",
                                        height: "0.8rem",
                                      }}
                                    ></span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </th>
                          <th>UOM</th>
                          <th>
                            Qty <span className="text-danger">*</span>
                          </th>
                          <th>
                            Rate <span className="text-danger">*</span>
                          </th>
                          {stkAdjType != 1 && (
                            <th>
                              Godown <span className="text-danger">*</span>
                            </th>
                          )}

                          <th>Amount</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formInputs.item_dtl &&
                          formInputs.item_dtl.map((v, i) => (
                            <tr
                              key={i}
                              data-id={i}
                              className={
                                highlightedRow === i ? "scan-highlight" : ""
                              }
                              onClick={() => setHighlightedRow(i)}
                            >
                              <td style={{ width: "380px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    // justifyContent: "center",
                                    alignItems: "center",
                                    gap: "1px",
                                  }}
                                >
                                  <CommonAsyncSelect
                                    ref={(el) =>
                                      (focus.current[0][`prod_id_${i}`] = el)
                                    }
                                    autoFocus={true}
                                    getOptionLabel={(o) => o.item_name}
                                    placeholder="Enter atleast 3 character"
                                    getOptionValue={(o) => o.item_id}
                                    noOptionsMessage={() => null}
                                    defaultOptions={itemList}
                                    isLoading={itemLoading}
                                    loadOptions={async (inputValue, callback) => {
                                      let currentList = itemList;
                                      if (inputValue) {
                                        const search = inputValue.toLowerCase().trim();
                                        currentList = itemList.filter((item) =>
                                          item.item_name?.toLowerCase().includes(search) ||
                                          item.barcode?.toLowerCase().includes(search) ||
                                          item.SKU?.toLowerCase().includes(search)
                                        );
                                      }
                                      callback(currentList);
                                    }}
                                    filterOption={(candidate, input) => {
                                      if (
                                        selectedProduct.find(
                                          (p) => p.item_id === candidate.value,
                                        )
                                      )
                                        return false;
                                      else return true;
                                    }}
                                    value={
                                      selectedProduct.find(
                                        (p) =>
                                          p.item_id ==
                                          formInputs.item_dtl[i].item_id,
                                      ) || null
                                    }
                                    onChange={async (e) => {
                                      if (e?.item_id) {
                                        await $.post(
                                          `${config.apiUrl}/item/listItem`,
                                          JSON.stringify({
                                            paginate: 0,
                                            is_active: 1,
                                            item_id: e.item_id,
                                          }),
                                          (res) => {
                                            const fullItem = res?.data?.list?.[0] || e;
                                            setSelectedProduct((prevState) => {
                                              let newState = [...prevState];
                                              newState[i] = fullItem;
                                              return newState;
                                            });
                                            handleTableInputs({
                                              target: {
                                                name: "item_id",
                                                value: fullItem,
                                              },
                                            }, i);
                                            focus.current[0][`qty${i}`].focus();
                                          }
                                        );
                                      }
                                    }}
                                    components={{
                                      IndicatorsContainer: () => null,
                                    }}
                                    styles={{
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        minHeight: "0px",
                                      }),
                                      valueContainer: (baseStyles, state) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                        width: "400px",
                                      }),
                                      input: (baseStyles, state) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                        marginTop: "0px",
                                        marginBottom: "0px",
                                        gridTemplateColumns: "0 100%",
                                      }),
                                      dropdownIndicator: (
                                        baseStyles,
                                        state,
                                      ) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                      }),
                                      option: (baseStyles, state) => ({
                                        ...baseStyles,
                                        paddingTop: "0px",
                                        paddingBottom: "0px",
                                      }),
                                    }}
                                    classNamePrefix="react-select"
                                    tabSelectsValue
                                  />
                                  {formInputs.item_dtl[i]?.item_id ? (
                                    <Tippy content="View Item">
                                      <div>
                                        {" "}
                                        <span
                                          className=""
                                          style={{ cursor: "pointer" }}
                                          onClick={() => handleItemView(v)}
                                        >
                                          <BiInfoCircle size={20} />
                                        </span>
                                      </div>
                                    </Tippy>
                                  ) : null}
                                </div>
                              </td>
                              <td style={{ width: "100px" }}>
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <select
                                    id=""
                                    name="uom"
                                    value={v?.uom}
                                    onChange={handleTableInputs}
                                    className="form-select"
                                    style={{ width: "100px" }}
                                  >
                                    {[v.base_uom, v.alt_uom].map((ele, ind) => (
                                      <option value={ele}>{ele}</option>
                                    ))}
                                  </select>
                                )}
                              </td>
                              <td style={{ width: "100px" }}>
                                <input
                                  ref={(el) =>
                                    (focus.current[0][`qty${i}`] = el)
                                  }
                                  type="text"
                                  className="form-control text-end"
                                  name="qty"
                                  value={v.qty}
                                  disabled={!formInputs.item_dtl[i]?.item_id}
                                  // maxLength={6}
                                  onChange={handleTableInputs}
                                  onKeyDown={(e) => {
                                    if (e.key == "Enter") {
                                      e.preventDefault();
                                      handleItemCount("+", i);
                                    } else {
                                      inputfourDigitDeciaml(e);
                                    }
                                  }}
                                  required
                                  onFocus={(e) =>
                                    setTimeout(() => {
                                      e.target.select();
                                    }, 50)
                                  }
                                />
                                {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span
                                    className="text-right"
                                    style={{
                                      wordBreak: "break-all",
                                      fontSize: "10px",
                                    }}
                                  >
                                    <TruncatedTextWithTooltip
                                      text={uomConversionUnit(v)}
                                    />
                                  </span>
                                )}
                              </td>
                              <td style={{ width: "130px", maxWidth: "130px" }}>
                                <input
                                  // ref={el => focus.current[0][`base_price_${i}`] = el}
                                  type="text"
                                  className="form-control text-end"
                                  name={
                                    v?.uom == v?.alt_uom ? "alt_price" : "rate"
                                  }
                                  value={
                                    v?.uom == v?.alt_uom
                                      ? v?.alt_price
                                      : v?.rate
                                  }
                                  disabled={!formInputs.item_dtl[i]?.item_id}
                                  maxLength={12}
                                  onChange={handleTableInputs}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.preventDefault();
                                      handleItemCount("+", i);
                                    } else {
                                      if (
                                        !/^\d*\.?\d{0,4}$/.test(
                                          e.target.value + e.key,
                                        ) &&
                                        e.key !== "Backspace" &&
                                        e.key !== "Tab"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }
                                  }}
                                  required
                                  onFocus={(e) =>
                                    setTimeout(() => {
                                      e.target.select();
                                    }, 50)
                                  }
                                />
                                {/* {v?.alt_uom != null && v?.alt_uom != "" && (
                                  <span style={{ whiteSpace: "nowrap" }}>
                                    {`Per (`}
                                    <TruncatedTextWithTooltip text={v?.base_uom} />
                                    {`)`}
                                  </span>
                                )} */}
                                {v?.alt_uom != null &&
                                  v?.alt_uom !== "" &&
                                  (v?.uom == v?.alt_uom ? (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`( ${v?.rate} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        wordBreak: "break-all",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {`(${v?.alt_price} Per `}
                                      <TruncatedTextWithTooltip
                                        text={uomConversion(v)}
                                      />
                                      {`)`}
                                    </span>
                                  ))}
                              </td>

                              {stkAdjType != 1 && (
                                <td width="170px">
                                  <select
                                    // disabled={godown.length === 0 ? true : false}
                                    className="form-select"
                                    name="godown_id"
                                    value={v.godown_id}
                                    onChange={handleTableInputs}
                                    disabled={!formInputs.item_dtl[i]?.item_id}
                                  >
                                    <option value="" hidden>
                                      Select...
                                    </option>
                                    {godown &&
                                      godown.map((list) => {
                                        // if (list.branch_id === branchId) {
                                        return (
                                          <option value={list.value}>
                                            {list.label}
                                          </option>
                                        );
                                        // }
                                      })}
                                  </select>
                                </td>
                              )}
                              <td>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  name="amount"
                                  // value={v.amount}
                                  value={millionComma(v?.amount)}
                                  disabled
                                />
                              </td>
                              <td
                                style={{
                                  width: "80px",
                                  verticalAlign: "middle",
                                }}
                              >
                                <img
                                  src={addIcon}
                                  style={{ width: "17px", height: "17px" }}
                                  className="img-fluid m-1"
                                  alt=""
                                  onClick={() => handleItemCount("+", i)}
                                  role="button"
                                />
                                <img
                                  src={deleteIcon}
                                  style={{ width: "17px", height: "17px" }}
                                  className="img-fluid m-1"
                                  alt=""
                                  onClick={() => handleItemCount("-", i)}
                                  role="button"
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="col-12 mt-2">
                    {(error || success) && (
                      <div
                        className={`alert alert-${error ? "danger" : "success"
                          } py-2 small`}
                        role="alert"
                      >
                        {error || success || ""}
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 position-absolute bottom-0 start-0 end-0">
                  <div
                    className="row rounded px-2 py-3"
                    style={{ background: "#F4F7FE" }}
                  >
                    <div className="col">
                      <label htmlFor="totalRef">Gross Total</label>
                      <input
                        type="text"
                        className="form-control text-end"
                        id="totalRef"
                        ref={totalRef}
                        disabled
                      />
                    </div>
                    <div className="col d-flex mt-auto justify-content-end">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        onClick={handleSubmit}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
      <Modal
        show={showItemModal}
        onHide={handleItemModalClose}
        keyboard={false}
        backdrop="static"
        size="lg"
      >
        <ItemViews id={selectedItemId} hide={handleItemModalClose} />
      </Modal>
    </>
  );
}

export default StockAdjustmentAdd;
